import React from 'react';
import { Tag } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

const MeetingStatus = ({ item, value }) => {
  let tagColor;
  let tagText;
  const tagProps = {};

  if (!!item.confirm_sale_citizen_id) {
    tagColor = 'success';
    tagText = 'Chốt lịch học BVLN';
    tagProps.icon = <CheckOutlined />;
  } else if (value === 0) {
    tagColor = 'orange';
    tagText = 'Chưa gặp';
  } else if (value) {
    tagColor = 'green';
    tagText = `Gặp ${value} lần`;
  }

  if (!tagText) {
    return null;
  }

  return (
    <Tag color={tagColor} {...tagProps}>
      {tagText}
    </Tag>
  );
};

export default MeetingStatus;
